<template>
  <div class="flex items-center">
    <div class="flex w-full bg-white rounded shadow border-transparent">
      <select class="relative px-2 py-2 p-0 w-full rounded-r focus:shadow-outline form-select outline-indigo-400" style="border: 0px !important;" autocomplete="off" name="skuType" placeholder="Select SKU Types" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
        <option
          v-for="channel in channels"
          :key="channel.id"
          :value="channel.name"
        >
          {{ channel.name }}
        </option>
      </select>
    </div>
  </div>
</template>
  
<script>
  
export default {
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
    channels: Object,
  },
  emits: ['update:modelValue'],
}
</script>
  